(() => {
  if (!customElements.get("sibling-colors")) {
    class SiblingColors extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.setHtmlElements();
        this.checkActiveColor();
      }

      setHtmlElements() {
        this.swatchesList = this.querySelector('.sibling-list');
      }

      async getProduct(handle) {
        try {
            const res = await fetch(`/products/${handle}?view=product`);
            const text = await res.text();
            const html = new DOMParser().parseFromString(text, 'text/html');
            return html;
        } catch (error) {
            console.log(error);
        }
      }

      checkActiveColor() {
        const productHandle = this.swatchesList.dataset.handle;
        const swatchesItems = this.swatchesList.querySelectorAll('li');
        const activeElement = Array.from(swatchesItems).find(element => element.dataset.productHandle === productHandle);
        if (activeElement) {
          activeElement.classList.add('active');
        }
      }
    }

    customElements.define("sibling-colors", SiblingColors);
  }
})();
